module.exports = __webpack_public_path__ + "img/asso_airbusan01.f3633f0a.png";